import { useState } from "react";
import { deleteUser } from "../services/userService";

interface ApiError {
  message?: string;
}

type DeactivateUserResult =
  | { success: true }
  | { success: false; message: string };

const useDeactivateUser = () => {
  const [loading, setLoading] = useState(false);

  const handleDeactivateUser = async (id: string): Promise<DeactivateUserResult> => {
    setLoading(true);
    const { error } = await deleteUser(id) as { error: ApiError | null };
    setLoading(false);

    if (error) {
      return {
        success: false,
        message: error.message || "Failed to deactivate user.",
      };
    }

    return { success: true };
  };

  return { handleDeactivateUser, loading };
};

export default useDeactivateUser;
